(function () {
  if (window.__bookCardInteractionsBound) return;

  window.__bookCardInteractionsBound = true;

  function isInteractiveTarget(target) {
    return Boolean(target.closest('a, button, input, select, textarea, [role="button"]'));
  }

  function openCard(card) {
    var url = card.dataset.productUrl;
    if (url) window.location.assign(url);
  }

  document.addEventListener('click', function (event) {
    var card = event.target.closest('[data-product-card][data-product-url]');
    if (!card || isInteractiveTarget(event.target)) return;

    openCard(card);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    var card = event.target.closest('[data-product-card][data-product-url]');
    if (!card || isInteractiveTarget(event.target)) return;

    event.preventDefault();
    openCard(card);
  });
})();
